/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";

import { Draggable } from "react-beautiful-dnd";
import { MdDragIndicator } from "react-icons/md";
import { IoTrash } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { DropdownSearchWithNoFormsy } from "../../common/DropdownSearch";

const DraggableItem = ({
  item,
  items,
  index,
  removeItem,
  count,
  onChange,
  employeeData,
  isNightMode,
  disabled
}) => (
  <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
    {(draggableProvided) => (
      <div
        ref={draggableProvided.innerRef}
        {...draggableProvided.draggableProps}
        {...draggableProvided.dragHandleProps}
        style={{
          borderRadius: "4px",
          backgroundColor: isNightMode ? "#1a2129" : "#eee",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          ...draggableProvided.draggableProps.style
        }}
      >
        <div style={{ display: "flex", flexGrow: 1, gap: 10 }}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <MdDragIndicator size={20} style={{ marginRight: "8px" }} />
            {item.text}
          </span>
          <div style={{ flexGrow: 1, height: "100%", overflow: "hidden" }}>
            <DropdownSearchWithNoFormsy
              isOptionDisabled={(option) =>
                items.some((i) => i.employee === option.value)
              }
              name="employee"
              label=""
              onChange={(_, v) => onChange(v, item.id)}
              value={item.employee}
              data={employeeData}
              menuPortalTarget={document.body}
              disabled={disabled}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (provided) => ({
                  ...provided,
                  background: isNightMode ? "#202832" : "#fff",
                  color: isNightMode ? "#fff" : "#000"
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: isNightMode
                    ? "#202832"
                    : state.isSelected
                      ? provided.backgroundColor
                      : "transparent",
                  "&:hover": {
                    backgroundColor: isNightMode
                      ? state.isDisabled
                        ? "transparent"
                        : "#343B44"
                      : provided.backgroundColor
                  }
                })
              }}
            />
          </div>
        </div>
        <button
          id={item.id}
          className="btn-icon"
          type="button"
          onClick={() => removeItem(item.id)}
          disabled={count < 2 || disabled}
          data-tooltip-variant={isNightMode ? "dark" : "light"}
        >
          <IoTrash style={{ verticalAlign: "middle" }} />
        </button>
        <ReactTooltip
          id={`remove-tooltip-${item.id}`}
          anchorId={item.id}
          place="left"
          className={`custom-tooltip ${isNightMode ? "dark" : "light"}`}
        >
          Remove
        </ReactTooltip>
      </div>
    )}
  </Draggable>
);

DraggableItem.propTypes = {
  item: PropTypes.object,
  items: PropTypes.array,
  index: PropTypes.number,
  removeItem: PropTypes.func,
  count: PropTypes.number,
  onChange: PropTypes.func,
  employeeData: PropTypes.array,
  isNightMode: PropTypes.bool,
  disabled: PropTypes.bool
};

DraggableItem.defaultProps = {
  items: []
};

export default DraggableItem;
